<template>
	<b-modal
		dialog-class="sc-modal-xl"
		hide-footer
		ref="modal-view"
		size="lg"
		@show="showModal"
		@hidden="$emit('closed')"
		:title="
			modelId > 0 ? 'Edición de plan tarifario' : 'Nuevo plan tarifario'
		"
	>
		<b-overlay :show="loading" no-wrap rounded="sm" opacity="0.85">
			<template #overlay>
				<div class="text-center p-4">
					<b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
					<p class="mt-3 mb-0">Cargando información...</p>
				</div>
			</template>
		</b-overlay>

		<section v-if="errorLoading && !loading">
			<b-alert show variant="danger" class="text-center">
				<md-icon icon="error_outline" class="mr-2"></md-icon>
				<strong>Error cargando la información</strong>
				<p class="mb-0 mt-2">Por favor, intente nuevamente o contacte al administrador.</p>
			</b-alert>
		</section>

		<section v-else>
			<b-breadcrumb v-if="modelId>0" class="bg-light rounded px-3 py-2 mb-3">
				<b-breadcrumb-item>Planes Tarifarios</b-breadcrumb-item>
				<b-breadcrumb-item v-if="!$root.isEmpty(saleChannelModel)">{{ saleChannelModel.name }}</b-breadcrumb-item>
				<b-breadcrumb-item v-if="!$root.isEmpty(supplierModel)">{{ supplierModel.name }}</b-breadcrumb-item>
				<b-breadcrumb-item active>
					<strong>ID: {{ modelId }}</strong>
				</b-breadcrumb-item>
			</b-breadcrumb>

			<b-tabs content-class="mt-3" align="center" pills card>
				<b-tab active>
					<template #title>
						<md-icon icon="settings"></md-icon>Información General
					</template>
					<b-form @submit="onSubmit">
						<!-- Información básica -->
						<div class="form-section mb-3">
							<div class="section-header mb-2">
								<md-icon icon="info" class="text-primary mr-1"></md-icon>
								<strong>Datos Básicos</strong>
							</div>
							<b-form-row>
								<b-form-group :class="!showSuppliers ? 'col-md-6' : 'col-12'" label="Nombre*" label-class="font-weight-semibold small">
									<b-input-group size="sm">
										<b-input-group-prepend>
											<b-input-group-text><md-icon icon="label" style="font-size: 18px;"></md-icon></b-input-group-text>
										</b-input-group-prepend>
										<b-form-input
											type="text"
											:disabled="unableEdit"
											v-model="modelInfo.name"
											required
										/>
									</b-input-group>
								</b-form-group>
								<b-form-group class="col-md-6" label="Tarifa padre" label-class="font-weight-semibold small" v-if="!embbebedOnSupplier && !showSuppliers">
									<div class="input-group-with-icon">
										<md-icon icon="account_tree" class="input-icon"></md-icon>
										<multiselect
											:disabled="
												!$hasPermission('prices.inherited') || unableEdit
											"
											@select="toggleSelected"
											:options="inheritableRatePlansOpts"
											v-model="modelInfo.parentRatePlanObj"
											:multiple="false"
											:close-on-select="true"
											:show-labels="false"
											label="text"
											track-by="value"
										/>
									</div>
								</b-form-group>
							</b-form-row>
							<b-form-row v-if="modelInfo.parentRatePlanId">
								<b-form-group
									class="col-md-6"
									label="Modificación de herencia"
									label-class="font-weight-semibold small"
								>
									<b-input-group size="sm">
										<b-input-group-prepend>
											<b-form-select
												:disabled="
													!$hasPermission('prices.inherited') ||
														unableEdit
												"
												v-model="modelInfo.heritanceModifierSign"
												:options="[
													{ value: 1, text: '+' },
													{ value: -1, text: '-' }
												]"
											/>
										</b-input-group-prepend>
										<b-form-input
											type="text"
											:disabled="
												!$hasPermission('prices.inherited') ||
													unableEdit
											"
											v-model="modelInfo.heritanceModifierAmount"
											required
										/>
										<b-input-group-append>
											<b-form-select
												:disabled="
													!$hasPermission('prices.inherited') ||
														unableEdit
												"
												v-model="modelInfo.heritanceModifierType"
												:options="[
													{ value: '%', text: '%' },
													{ value: '$', text: '$' }
												]"
											/>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-form-row>
							<b-form-row v-if="!modelInfo.parentRatePlanId">
								<b-form-group class="col-md-2" label="Moneda" label-class="font-weight-semibold small">
									<b-input-group size="sm">
										<b-input-group-prepend>
											<b-input-group-text><md-icon icon="payments" style="font-size: 18px;"></md-icon></b-input-group-text>
										</b-input-group-prepend>
										<b-form-select
											:disabled="unableEdit"
											v-model="modelInfo.currency"
											:options="currencyOptions"
										></b-form-select>
									</b-input-group>
								</b-form-group>
								<b-form-group class="col-md-5" label="Área Shuttle Central*" label-class="font-weight-semibold small">
									<multiselect
										v-if="!embbebedOnSupplier"
										:disabled="unableEdit"
										@select="toggleSelectedArea"
										:options="$root.auxVars.zonedAreasOpts"
										v-model="modelInfo.zonedAreaObject"
										:multiple="false"
										ref="zonedArea"
										:show-labels="false"
										label="text"
										track-by="value"
									/>
									<multiselect
										v-else
										:disabled="unableEdit"
										@select="toggleSelectedArea"
										:options="zonedAreaMaster"
										v-model="modelInfo.zonedAreaObject"
										:multiple="false"
										ref="zonedArea"
										:show-labels="false"
										label="text"
										track-by="value"
									/>
								</b-form-group>
								<b-form-group v-show="showSuppliers" class="col-md-5" label="Área Proveedor*" label-class="font-weight-semibold small">
									<multiselect
										:disabled="unableEdit"
										@select="toggleSelectedSupplierArea"
										:options="$root.auxVars.zonedAreasOpts"
										v-model="modelInfo.supplierZonedAreaObject"
										:multiple="false"
										ref="supplierZA"
										:show-labels="false"
										label="text"
										track-by="value"
									/>
								</b-form-group>
							</b-form-row>
						</div>

						<!-- Configuración de tarifa -->
						<div class="form-section mb-3">
							<div class="section-header mb-2">
								<md-icon icon="tune" class="text-primary mr-1"></md-icon>
								<strong>Configuración de Tarifa</strong>
							</div>
							<b-form-row>
								<b-form-group class="col-md-4" label="Tipo" label-class="font-weight-semibold small">
									<b-input-group size="sm">
										<b-input-group-prepend>
											<b-input-group-text><md-icon icon="category" style="font-size: 18px;"></md-icon></b-input-group-text>
										</b-input-group-prepend>
										<b-form-select
											:disabled="unableEdit"
											v-model="modelInfo.rateType"
											:options="rateTypeOptions"
										></b-form-select>
									</b-input-group>
								</b-form-group>
								<b-form-group class="col-md-3" label="Descuento" label-class="font-weight-semibold small">
									<b-input-group size="sm">
										<b-input-group-prepend>
											<b-input-group-text><md-icon icon="local_offer" style="font-size: 18px;"></md-icon></b-input-group-text>
										</b-input-group-prepend>
										<b-form-input
											:disabled="unableEdit"
											type="number"
											step="0.01"
											v-model="modelInfo.percentageDiscount"
											required
										/>
										<template #append>
											<b-input-group-text>%</b-input-group-text>
										</template>
									</b-input-group>
								</b-form-group>
								<b-form-group class="col-md-5" label="Meet & Greet" label-class="font-weight-semibold small">
									<div class="d-flex align-items-center h-100">
										<b-form-checkbox
											v-model="modelInfo.meetAndGreet"
											name="meetAndGreet"
											switch
											size="lg"
											class="mt-1"
										>
											<md-icon icon="emoji_people" class="mr-1"></md-icon>
											<span>Disponible</span>
										</b-form-checkbox>
									</div>
								</b-form-group>
							</b-form-row>
							<b-form-row v-if="!embbebedOnSupplier">
								<b-form-group
									class="col-md-5"
									label="Asignación automática de Proveedor"
									label-class="font-weight-semibold small"
								>
									<b-input-group size="sm">
										<b-input-group-prepend>
											<b-input-group-text><md-icon icon="auto_awesome" style="font-size: 18px;"></md-icon></b-input-group-text>
										</b-input-group-prepend>
										<b-form-select
											:disabled="unableEdit"
											v-model="modelInfo.defaultSupplierId"
											:options="suppliersOpts"
										/>
									</b-input-group>
								</b-form-group>
								<b-form-group class="col-md-3" label="Operación externa" label-class="font-weight-semibold small">
									<b-input-group size="sm">
										<b-input-group-prepend>
											<b-input-group-text><md-icon icon="sync_alt" style="font-size: 18px;"></md-icon></b-input-group-text>
										</b-input-group-prepend>
										<b-form-select
											:disabled="unableEdit"
											v-model="modelInfo.externallyOperatedServices"
											:options="[
												{ text: 'SI', value: true },
												{ text: 'NO', value: false }
											]"
										/>
									</b-input-group>
								</b-form-group>
								<b-form-group class="col-md-4" label="Tipo de tarifa" label-class="font-weight-semibold small">
									<b-input-group size="sm">
										<b-input-group-prepend>
											<b-input-group-text><md-icon icon="label_important" style="font-size: 18px;"></md-icon></b-input-group-text>
										</b-input-group-prepend>
										<b-form-select
											:disabled="unableEdit"
											v-model="modelInfo.type"
											:options="ratePlanTypeOpts"
										></b-form-select>
									</b-input-group>
								</b-form-group>
							</b-form-row>

							<b-form-row>
								<b-form-group class="col-12" label="Tipos de servicio (Opcional)" label-class="font-weight-semibold small" v-if="!embbebedOnSupplier">
									<div class="input-group-with-icon">
										<md-icon icon="directions_car" class="input-icon"></md-icon>
										<multiselect
											class="stacked-options"
											:disabled="unableEdit"
											:options="servicesTypes"
											v-model="serviceTypesSelected"
											multiple
											label="text"
											track-by="value"
											taggable
											required
										/>
									</div>
								</b-form-group>
								<b-form-group class="col-12" label="Tipos de servicio (Opcional)" label-class="font-weight-semibold small" v-else>
									<multiselect
										class="stacked-options"
										:disabled="unableEdit"
										:options="serviceTypesBySupplierId"
										v-model="serviceTypesSelected"
										multiple
										label="text"
										track-by="value"
										taggable
									/>
								</b-form-group>
							</b-form-row>
						</div>
						<!-- Información de tarifa padre -->
						<div v-if="selectedParentRatePlan !== null" class="form-section mb-3">
							<div class="section-header mb-2">
								<md-icon icon="account_tree" class="text-primary mr-1"></md-icon>
								<strong>Datos de Tarifa Padre</strong>
							</div>
							<b-card class="border-left-primary shadow-sm">
								<b-button variant="info" size="sm" @click="openRatePlanBase" class="mb-2">
									<md-icon icon="visibility" class="mr-1"></md-icon>Ver tarifa Padre
								</b-button>
								<div class="d-flex flex-wrap">
									<div class="mr-4 mb-2">
										<small class="text-muted d-block">Área:</small>
										<strong>{{ selectedParentRatePlan.zonedArea.name }}</strong>
									</div>
									<div class="mr-4 mb-2">
										<small class="text-muted d-block">Moneda:</small>
										<strong>{{ selectedParentRatePlan.currency.toUpperCase() }}</strong>
									</div>
								</div>
								<div>
									<small class="text-muted d-block mb-1">Tipos de servicio:</small>
									<b-badge v-for="serviceType in selectedParentRatePlan.serviceTypes" :key="serviceType.id" variant="secondary" class="mr-1 mb-1">
										{{ serviceType.name }}
									</b-badge>
								</div>
							</b-card>
						</div>

						<!-- Fechas y ventanas -->
						<div v-if="showSuppliers || showSalesChannels" class="form-section mb-3">
							<div class="section-header mb-2">
								<md-icon icon="event" class="text-primary mr-1"></md-icon>
								<strong>Fechas y Ventanas</strong>
							</div>
							<b-row>
								<b-col md="6">
									<b-form-group :label="bookingWindowStartLabel" label-class="font-weight-semibold small">
										<b-input-group size="sm">
											<b-input-group-prepend>
												<b-input-group-text><md-icon icon="event_available" style="font-size: 18px;"></md-icon></b-input-group-text>
											</b-input-group-prepend>
											<b-form-datepicker
												v-model="modelInfo.startDate"
												size="sm"
											></b-form-datepicker>
										</b-input-group>
									</b-form-group>
								</b-col>
								<b-col md="6">
									<b-form-group :label="bookingWindowEndLabel" label-class="font-weight-semibold small">
										<b-input-group size="sm">
											<b-input-group-prepend>
												<b-input-group-text><md-icon icon="event_busy" style="font-size: 18px;"></md-icon></b-input-group-text>
											</b-input-group-prepend>
											<b-form-datepicker
												v-model="modelInfo.endDate"
												reset-button
												size="sm"
											></b-form-datepicker>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row v-if="showSuppliers">
								<b-col md="6">
									<b-form-group label="Fecha de viaje - Inicio (Opcional)" label-class="font-weight-semibold small">
										<b-input-group size="sm">
											<b-input-group-prepend>
												<b-input-group-text><md-icon icon="flight_takeoff" style="font-size: 18px;"></md-icon></b-input-group-text>
											</b-input-group-prepend>
											<b-form-datepicker
												v-model="modelInfo.travelWindowStartDate"
												reset-button
												size="sm"
											></b-form-datepicker>
										</b-input-group>
									</b-form-group>
								</b-col>
								<b-col md="6">
									<b-form-group label="Fecha de viaje - Fin (Opcional)" label-class="font-weight-semibold small">
										<b-input-group size="sm">
											<b-input-group-prepend>
												<b-input-group-text><md-icon icon="flight_land" style="font-size: 18px;"></md-icon></b-input-group-text>
											</b-input-group-prepend>
											<b-form-datepicker
												v-model="modelInfo.travelWindowEndDate"
												reset-button
												size="sm"
											></b-form-datepicker>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row v-if="showSuppliers">
								<b-col md="6">
									<b-form-group label="Hora servicio - Inicio (Opcional)" label-class="font-weight-semibold small">
										<TimeField
											v-model="modelInfo.serviceStartTime"
										></TimeField>
									</b-form-group>
								</b-col>
								<b-col md="6">
									<b-form-group label="Hora servicio - Fin (Opcional)" label-class="font-weight-semibold small">
										<TimeField
											v-model="modelInfo.serviceEndTime"
										></TimeField>
									</b-form-group>
								</b-col>
							</b-row>
						</div>

						<!-- Descripción y configuración adicional -->
						<div class="form-section mb-3">
							<div class="section-header mb-2">
								<md-icon icon="description" class="text-primary mr-1"></md-icon>
								<strong>Información Adicional</strong>
							</div>
							<b-form-row>
								<b-form-group class="col-12" label="Descripción (Opcional)" label-class="font-weight-semibold small">
									<b-textarea size="sm" v-model="modelInfo.description" rows="3" />
								</b-form-group>
							</b-form-row>

							<template v-if="showSuppliers || showSalesChannels">
								<b-form-row>
									<b-form-group class="col-md-6" v-if="showSuppliers" label="Proveedor" label-class="font-weight-semibold small">
										<b-input-group size="sm">
											<b-input-group-prepend>
												<b-input-group-text><md-icon icon="business_center" style="font-size: 18px;"></md-icon></b-input-group-text>
											</b-input-group-prepend>
											<b-form-select
												disabled
												v-model="modelInfo.supplierId"
												:options="suppliersOpts"
											></b-form-select>
										</b-input-group>
									</b-form-group>
									<b-form-group class="col-md-6" v-if="showSalesChannels" label="Canal de venta" label-class="font-weight-semibold small">
										<b-input-group size="sm">
											<b-input-group-prepend>
												<b-input-group-text><md-icon icon="storefront" style="font-size: 18px;"></md-icon></b-input-group-text>
											</b-input-group-prepend>
											<b-form-select
												disabled
												v-model="modelInfo.salesChannelId"
												:options="salesChannelsOpts"
											></b-form-select>
										</b-input-group>
									</b-form-group>
								</b-form-row>
							</template>
						</div>

						<div class="text-right pt-2 border-top">
							<b-button
								:disabled="unableEdit"
								variant="primary"
								type="submit"
								size="md"
								class="px-4"
							>
								<md-icon :icon="modelId > 0 ? 'save' : 'add_circle'" class="mr-1"></md-icon>
								{{ modelId > 0 ? "Actualizar" : "Guardar" }}
							</b-button>
						</div>
					</b-form>
				</b-tab>
				<b-tab v-if="modelId>0" lazy>
					<template #title>
						<md-icon icon="attach_money"></md-icon>Precios  <small><b-badge variant="warning">Beta</b-badge></small>
					</template>
					<ratePlanModulePrices :ratePlanId=modelId></ratePlanModulePrices>
				</b-tab>
				<b-tab v-if="modelId>0 && applyPromoMod" lazy >
					<template #title>
						<md-icon icon="sell"></md-icon>Promociones
					</template>
					<IndexPromotionsSalesChannel :ratePlanId="modelId" :salesChannelId="saleChannelModel.id" v-if="!$root.isEmpty(saleChannelModel)"></IndexPromotionsSalesChannel>
					<IndexPromotionsSupplier :ratePlanId="modelId" :idSupplier="supplierModel.id" v-if="!$root.isEmpty(supplierModel)"></IndexPromotionsSupplier>
				</b-tab>
				<b-tab v-if="modelId>0" lazy >
					<template #title>
						<md-icon icon="event_busy"></md-icon>Cierre de ventas
					</template>
					<AjaxTable id="places-index-list" :columns="lock.columns" :filters="filtersForLocks" resource="locks">
						<template #cell(ratePlan)="row">
							<div v-if="row.item.ratePlan != null">
								{{ row.item.ratePlan.name }}
							</div>
						</template>
						<template #cell(actions)="row">
							<div class="text-center">
								<b-button  @click="(event) => editModel(row.item.id)" type="button" size="sm" class="mr-1" variant="info">
									<md-icon icon="edit" />
								</b-button>
								<b-button v-if="$hasPermission('stopSale.delete')" @click="(event) => modelDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
									<md-icon icon="delete" />
								</b-button>
							</div>
						</template>
					</AjaxTable>
				</b-tab>
				<b-tab lazy v-if="modelId>0 && showSalesChannels">
					<template #title>
						<md-icon icon="point_of_sale"></md-icon>Puntos de venta
					</template>
					<b-alert show class="text-center">Puntos de venta que están distribuyendo el plan tarifario</b-alert>
					<AjaxTable id="places-index-list" :columns="pos.columns" :filters="{}" :resource="resourcePos">
						<template #cell(domain)="row">
							<a :href="'https:'+row.item.domain" target="_blank"> {{row.item.domain}} </a>
						</template>
					</AjaxTable>
				</b-tab>
				<b-tab lazy v-if="modelId>0">
					<template #title>
						<md-icon icon="history"></md-icon> Logs
					</template>
					<change-logs :ratePlanId="modelId" />
				</b-tab>
			</b-tabs>

			<RpForm
				:unableEdit="true"
				ref="ratePlanSingleParent"
			/>

		</section>


	</b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
// import FormGroupBox from "../../helpers/FormGroupBox";
import moment from "moment";
import ratePlanModulePrices from "../../sections/rate-plans/EditRates.vue"
import IndexPromotionsSalesChannel from "../../sections/sales-channels/IndexPromotions.vue"
import IndexPromotionsSupplier from "../../sections/suppliers/Promotions/indexPromotions.vue"
import AjaxTable from '../../helpers/AjaxTable.vue'
import changeLogs from "./ChangeLogs.vue"
import TimeField from "../../helpers/TimeField";

export default {
	name:"RpForm",
	props: {
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		},
		embbebedOnSupplier: Boolean,
		supplierId: Number,
		unableEdit: Boolean
	},
	components: { Multiselect,ratePlanModulePrices,IndexPromotionsSalesChannel,IndexPromotionsSupplier ,AjaxTable,changeLogs, TimeField},
	data() {
		let defaultModelInfo = {
			id: -1,
			name: "",
			currency: "mxn",
			description: "",
			zonedAreaId: null,
			supplierZonedAreaId: null,
			zonedAreaObject: null,
			supplierZonedAreaObject: null,
			rateType: "net",
			percentageDiscount: 0,
			type: "sc",
			meetAndGreet: true,
			parentRatePlanId: null,
			parentRatePlanObj: { value: null, text: "SIN HERENCIA" },
			heritanceModifierSign: 1,
			heritanceModifierType: "%",
			heritanceModifierAmount: 0,
			externallyOperatedServices: false,

			serviceTypes: [],
			supplierId: null,
			defaultSupplierId: null,
			salesChannelId: null,
			status: "active",

			startDate: null,
			endDate: null,

			travelWindowStartDate: null,
			travelWindowEndDate: null,

			serviceStartTime: null,
			serviceEndTime: null
		};
		return {
			modelId: -1,
			loading: true,
			modelInfo: { ...defaultModelInfo },
			defaultModelInfo: { ...defaultModelInfo },
			currencyOptions: [
				{ value: "mxn", text: "MXN" },
				{ value: "usd", text: "USD" },
				{ value: "eur", text: "EUR" }
			],
			rateTypeOptions: [
				{ value: "net", text: "Tarifa Neta" },
				{ value: "public", text: "Tarifa Publica" }
			],
			ratePlanTypeOpts: [
				{ value: "sc", text: "Shuttle Central" },
				{ value: "jayride", text: "Jayride" }
			],
			serviceTypesBySupplierId: [],
			zonedAreaMaster: [],
			showSuppliers: false,
			showSalesChannels: false,
			inheritableRatePlans: [],
			lock:{
				columns: [
                    {key: 'id',             label: 'ID'},
                    {key: 'description',    label: 'Descripción'},
                    {key: 'startDateH',     label: 'Inicio'},
                    {key: 'endDateH',       label: 'Fin'},
                    {key: 'ratePlan.title', label: 'Plan tarifario'},
                    {key: 'status',         label: 'Estatus'},
                    {key: 'actions',        label: 'Acciones'}
                ]
			},
			pos:{
				columns: [
					{key: 'id',     label: 'ID'},
					{key: 'codename',   label: 'Nombre'},
					{key: 'domain', label: 'Dominio'},
				]
			}
		};
	},
	computed: {
		bookingWindowStartLabel() {
			if (this.showSuppliers === true) {
				return "Fecha de asignación - Inicio*"
			} else {
				return "Fecha inicio*"
			}
		},
		bookingWindowEndLabel() {
			if (this.showSuppliers === true) {
				return "Fecha de asignación - Fin (Opcional)"
			} else {
				return "Fecha fin (Opcional)";
			}
		},
		inheritableRatePlansOpts() {
			return [
				{ value: null, text: "SIN HERENCIA" },
				...this.inheritableRatePlans.map(rp => ({
					value: rp.id,
					text: rp.title
				}))
			];
		},
		selectedParentRatePlan() {
			if (this.modelInfo.parentRatePlanObj == null) return null;
			const aux = this.inheritableRatePlans.find(
				rp => rp.id == this.modelInfo.parentRatePlanId
			);
			return typeof aux === "undefined" ? null : aux;
		},
		serviceTypesSelected: {
			get: function() {
				return this.modelInfo.serviceTypes.map(st => ({
					value: st.id,
					text: st.name
				}));
			},
			set: function(value) {
				this.modelInfo.serviceTypes = value.map(st => ({
					id: st.value,
					name: st.text
				}));
			}
		},
		salesChannelsOpts() {
			return [
				{ value: null, text: "N/A" },
				...this.$root.auxVars.salesChannelsOpts
			];
		},
		suppliersOpts() {
			return [
				{ value: null, text: "N/A" },
				...this.$root.auxVars.suppliersOpts
			];
		},
		servicesTypes() {
			let services = {};
			if (this.modelInfo.parentRatePlanId != null) {
				const aux = this.inheritableRatePlans.find(
					rp => rp.id == this.modelInfo.parentRatePlanId
				);
				let aux2 = typeof aux === "undefined" ? null : aux;

				services = aux2?.serviceTypes.map(st => ({
					value: st.id,
					text: "[" + st.id + "] " + st.code
				}));
			} else {
				services = this.$root.auxVars.serviceTypesOpts.map(st => ({
					value: st.value,
					text: "[" + st.value + "] " + st.text
				}));
			}

			return services || [];
		},
		zonedModel: {
			get() {
				return this.modelInfo.zonedAreaObject;
			},

			set(value) {
				let result = this.$root.auxVars.zonedAreasOpts.find(
					za => za.value == value.value
				);
				this.$refs.zonedArea?.$emit("input", result);
			}
		},
		supplierZonedModel: {
			get() {
				return this.modelInfo.supplierZonedAreaObject;
			},

			set(value) {
				let result = this.$root.auxVars.zonedAreasOpts.find(
					za => za.value == value.value
				);
				this.$refs.supplierZA?.$emit("input", result);
			}
		},
		saleChannelModel(){
			if(this.$root.isEmpty(this.modelInfo.salesChannel)) return null;
			return this.modelInfo.salesChannel
		},
		supplierModel(){
			if(this.$root.isEmpty(this.modelInfo.supplier)) return null;
			return this.modelInfo.supplier;
		},
		applyPromoMod(){
			if(this.showSuppliers || this.showSalesChannels) return true;
			return false
		},
		filtersForLocks(){
			return {search:"",ratePlanId:this.modelId}
		},
		resourcePos(){
			return `rate-plans/${this.modelId}/resources/pointOfSales`
		},
		errorLoading(){
			return (this.modelId != this.modelInfo.id)
		}
	},
	methods: {
		toggleSelected(selectedOption) {
			this.modelInfo.parentRatePlanId = selectedOption.value;
			this.serviceTypesSelected = []
		},
		toggleSelectedArea(selectedOption) {
			this.modelInfo.zonedAreaId = selectedOption.value;
		},
		toggleSelectedSupplierArea(selectedOption) {
			this.modelInfo.supplierZonedAreaId = selectedOption.value;
		},
		onSubmit(event) {
			event.preventDefault();
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			if (
				!this.modelInfo.parentRatePlanId &&
				(this.modelInfo.zonedAreaObject == null ||
					this.modelInfo.zonedAreaObject.lenght <= 0)
			) {
				this.$root.showAlert("Se debe seleccionar un Area", {
					variant: "warning"
				});
				return;
			}

			if (!this.modelInfo.parentRatePlanId && (this.modelInfo.supplierZonedAreaObject == null ||
					this.modelInfo.supplierZonedAreaObject.lenght <= 0) && this.showSuppliers) {
				this.$root.showAlert("Se debe seleccionar un Area de proveedor", {
					variant: "warning"
				});
				return;
			}
			//ingreso desde supplier(proveedor)?
			if (this.showSuppliers) {
				//validamos las fechas
				if (this.modelInfo.startDate == null) {
					this.$root.showAlert("Se debe seleccionar una fecha de inicio para la asignación",{variant: "warning"});
					return;
				}
			}

			// Validación de fechas startDate y endDate
			if (this.modelInfo.startDate && this.modelInfo.endDate) {
				const startDate = new Date(this.modelInfo.startDate);
				const endDate = new Date(this.modelInfo.endDate);

				if (endDate < startDate) {
					this.$root.showAlert("La fecha de fin no puede ser menor a la fecha de inicio",{variant: "warning"});
					return;
				}
			}

			// Validación de fechas travelWindow
			if (this.modelInfo.travelWindowStartDate && this.modelInfo.travelWindowEndDate) {
				const travelStart = new Date(this.modelInfo.travelWindowStartDate);
				const travelEnd = new Date(this.modelInfo.travelWindowEndDate);

				if (travelEnd < travelStart) {
					this.$root.showAlert("La fecha de viaje fin no puede ser menor a la fecha de viaje inicio",{variant: "warning"});
					return;
				}
			}

			// Validación: Si existe travelWindowEndDate, debe existir travelWindowStartDate
			if (this.modelInfo.travelWindowEndDate && !this.modelInfo.travelWindowStartDate) {
				this.$root.showAlert("Si especifica una fecha de viaje fin, debe especificar también la fecha de viaje inicio",{variant: "warning"});
				return;
			}

			this.loading = true;
			let rParams = {
				url:
					this.modelId > 0
						? `/rate-plans/${this.modelId}`
						: "/rate-plans",
				method: this.modelId > 0 ? "put" : "post"
			};
			if (rParams.method == "get") {
				rParams["params"] = this.modelInfo;
			} else {
				rParams["data"] = this.modelInfo;
			}
			this.$root.api
				.request(rParams)
				.then(res => {
					//validamos que sea una respuestas 200 o 2001 del lado del servidor
					if (res.status == 200 || res.status == 201) {
						this.$root.showAlert("OK!");
						if (res.data.id) this.loadModel(res.data.id);
						this.successCallback(res);
						this.$root.auxVars.resetResource("ratePlansOpts");
					}
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		loadModel(id) {
			this.loadInheritableRates();
			this.modelId = id;
			this.$refs["modal-view"].show();

			setTimeout(()=>{
				this.fetchModel();
			},0)

		},
		loadInheritableRates() {
			if (!this.showSuppliers) {
				this.$root.api
					.get(`/rate-plans-inheritables`)
					.then(res => {
						this.inheritableRatePlans = res.data;
					})
					.catch(this.$root.handleRequestError);
			}
		},
		fetchModel() {
			if (this.modelId > 0) {
				this.$emit(
					"update:unableEdit",
					!this.$hasPermission("rates.edit")
				);
				this.loading = true;

				// Primero resetear modelInfo para limpiar los campos del formulario
				this.modelInfo = { ...this.defaultModelInfo };

				this.$root.api
					.get(`/rate-plans/${this.modelId}`)
					.then(res => {

						this.modelInfo = {
							...res.data,
							serviceTypes: res.data.serviceTypes.map(st => ({
								id: st.id,
								name: "[" + st.id + "] " + st.code
							})),
							serviceStartTime: res.data.serviceStartTime ?? null,
							serviceEndTime: res.data.serviceEndTime ?? null
						};

						if (this.modelInfo.parentRatePlanId == null) {
							this.modelInfo.parentRatePlanObj = {
								value: null,
								text: "SIN HERENCIA"
							};
						} else {
							this.modelInfo.parentRatePlanObj = {
								value: this.modelInfo.parentRatePlanId,
								text: this.modelInfo.parentRatePlanTitle
							};
						}

						if (this.modelInfo.zonedAreaId != null) {
							let result = this.$root.auxVars.zonedAreasOpts.find(
								za => za.value == this.modelInfo.zonedAreaId
							);
							this.$refs.zonedArea?.$emit("input", result);
						}

						if (this.modelInfo.supplierZonedAreaId != null) {

							let result2 = this.$root.auxVars.zonedAreasOpts.find(
								za => za.value == this.modelInfo.supplierZonedAreaId
							);
							this.$refs.supplierZA?.$emit("input", result2);
						}

						if (this.modelInfo.supplierId > 0)
							this.showSuppliers = true;
						if (this.modelInfo.salesChannelId > 0)
							this.showSalesChannels = true;
						this.loading = false;
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.loading = false;
			}
		},
		setSupplierId(supplierId) {
			this.modelInfo.supplierId = supplierId;
			this.showSuppliers = true;
		},
		setSalesChannelId(salesChannelId) {
			this.modelInfo.salesChannelId = salesChannelId;
			this.showSalesChannels = true;
		},
		getMasterZonedAreas() {
			this.zonedAreaMaster = []
			this.$root.api
				.get(`zoned-areas/master`)
				.then(({data})=>{
					this.zonedAreaMaster = data.map(item => ({value: item.id, text: item.name}))
				})
				.catch((e)=> {
					console.error('ERROR => load master zoned areas', e.message)
				})
		},
		loadServiceTypeBySupplierId() {
			this.$root.api.get('/service-types', {
				params: {
					limit: 2001,
					filters: {
						config: {
							belongsTo: "supplier",
							supplierId: this.supplierId
						}
				} },
			}).then(response => {
				const rows = response.data.rows || response.data;
				this.serviceTypesBySupplierId = rows.map(item => ({
					value: item.id,
					text: item.code
				}));
			})
		},
		showModal() {
			if (this.embbebedOnSupplier) {
				this.loadServiceTypeBySupplierId()
				this.getMasterZonedAreas()
			}
		},
		openRatePlanBase(){
			this.$refs.ratePlanSingleParent.loadModel(this.selectedParentRatePlan.id);
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: [
				"zonedAreasOpts",
				"salesChannelsOpts",
				"suppliersOpts",
				"serviceTypesOpts"
			]
		});

		this.modelInfo.startDate = moment(new Date().toDateString()).format(
			"YYYY-MM-DD"
		);
		this.modelInfo.endDate = moment(new Date().toDateString()).format(
			"YYYY-MM-DD"
		);
		// console.log(this.modelInfo);
	},
	watch: {}
};
</script>

<style scoped>
/* Secciones del formulario */
.form-section {
	background-color: #f8f9fa;
	border-radius: 8px;
	padding: 1rem;
	border-left: 3px solid #007bff;
}

.section-header {
	display: flex;
	align-items: center;
	font-size: 0.95rem;
	color: #495057;
	padding-bottom: 0.5rem;
	border-bottom: 1px solid #dee2e6;
}

/* Multiselect con icono */
.input-group-with-icon {
	position: relative;
}

.input-group-with-icon .input-icon {
	position: absolute;
	left: 10px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 10;
	color: #6c757d;
	font-size: 18px;
	pointer-events: none;
}

.input-group-with-icon .multiselect {
	padding-left: 35px;
}

/* Card con borde izquierdo */
.border-left-primary {
	border-left: 4px solid #007bff !important;
}

.shadow-sm {
	box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

/* Labels más compactos */
.font-weight-semibold {
	font-weight: 600;
}

.small {
	font-size: 0.875rem;
}

/* Ajuste de inputs pequeños */
.input-group-sm > .input-group-prepend > .input-group-text {
	padding: 0.25rem 0.5rem;
	font-size: 0.875rem;
}

/* Stacked multiselect tags */
.stacked-options .multiselect__tag {
	float: left;
}

/* Espaciado mejorado */
.form-group {
	margin-bottom: 0.75rem;
}

/* Botones compactos con iconos */
.btn md-icon {
	vertical-align: middle;
	font-size: 18px;
}

/* Breadcrumb más compacto */
.breadcrumb {
	margin-bottom: 1rem;
	padding: 0.5rem 1rem;
	font-size: 0.85rem;
}

/* Tabs más compactos */
.card-header .nav-pills .nav-link {
	padding: 0.5rem 1rem;
	font-size: 0.9rem;
}

/* Badges en información de tarifa padre */
.badge {
	font-weight: 500;
	padding: 0.35em 0.65em;
}

/* Ajuste de tarjetas */
.card {
	border-radius: 8px;
}

.card-body {
	padding: 1rem;
}

/* Responsive - menos padding en móviles */
@media (max-width: 768px) {
	.form-section {
		padding: 0.75rem;
	}

	.input-group-with-icon .multiselect {
		padding-left: 30px;
	}

	.section-header {
		font-size: 0.9rem;
	}
}
</style>
